import styled from 'styled-components';

export const Details = styled.div`
	padding: 0.25rem 0rem;
	display: flex;
	justify-content: space-between;
	flex-direction: column;
	height: 100%;
`;

export const DetailTitle = styled.span`
	font-weight: 600;
	font-size: 0.8rem;
	margin-bottom: 0.2rem;
`;

export const DetailDescription = styled.span`
	font-weight: 400;
	font-size: 0.8rem;
`;
